import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Home/Footer";
import OurCollobrationImage from "../assets/img/OurCollobration.png";
import OurCollobrationSliderImage1 from "../assets/img/OurCollobrationSlider1.jpg";
import OurCollobrationSliderImage2 from "../assets/img/OurCollobrationSlider2.jpg";
import OurCollobrationSliderImage3 from "../assets/img/OurCollobrationSlider3.jpg";

const carouselData = [
  {
    image: OurCollobrationSliderImage1,
    title:
      "At IPDA, collaboration is at the heart of transformation. We are proud to partner with globally recognized institutions—ICAR-Indian Institute of Pulses Research (ICAR-IIPR), International Crops Research Institute for the Semi-Arid Tropics (ICRISAT), and the Good Food Institute India (GFI India).",
  },
  {
    image: OurCollobrationSliderImage2,
    title:
      "These strategic alliances bring together world-class research, innovation, and technical expertise to accelerate breakthroughs in the pulses sector.",
  },
  {
    image: OurCollobrationSliderImage3,
    title:
      " Our mission is to ensure sustainable and efficient pulses value chains through collaboration, research, and training initiatives",
  },
];

const Collobration = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div>
      <main className="main">
        {/* Page Title */}
        <section className="carousel-section" data-aos="fade-up">
          <Swiper
            modules={[Autoplay]}
            pagination={{ clickable: true }}
            navigation={false}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            className="custom-swiper"
          >
            {carouselData.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className="carousel-item"
                  style={{ backgroundImage: `url('${slide.image}')` }}
                >
                  <div className="overlay">
                    <h3 style={{ color: "white" }}>{slide.title}</h3>
                    <p>{slide.description}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>

        {/* About Section */}
        <div className="section-separator" data-aos="fade-up">
          <h2 className="separator-title" style={{ color: "#d4561a" }}>
            Our Collaborations
          </h2>
          <div className="separator-line" data-aos="fade-left"></div>
        </div>
        <section
          id="collaboration"
          className="collaboration section py-5"
          style={{ backgroundColor: "white" }}
          data-aos="fade-up"
        >
          <div className="container">
            <div className="row align-items-center gap-5 px-3">
              {/* Image on the Left */}
              <div className="col-lg-5" data-aos="zoom-in">
                <img
                  src={OurCollobrationImage}
                  alt="Collaboration"
                  className="img-fluid rounded shadow"
                  style={{
                    width: "100%",
                    maxHeight: "450px",
                    objectFit: "cover",
                  }}
                />
              </div>

              {/* Content on the Right */}
              <div className="col-lg-6 mt-4 mt-lg-0 my-4" data-aos="fade-left">
                <p className="text-dark mt-3 fw-bold">
                  At IPDA, collaboration is at the heart of transformation. We
                  are proud to partner with globally recognized
                  institutions—ICAR-Indian Institute of Pulses Research
                  (ICAR-IIPR), International Crops Research Institute for the
                  Semi-Arid Tropics (ICRISAT), and the Good Food Institute India
                  (GFI India). These strategic alliances bring together
                  world-class research, innovation, and technical expertise to
                  accelerate breakthroughs in the pulses sector. From advancing
                  climate-resilient seed systems and sustainable agronomic
                  practices to driving next-generation plant-based protein
                  solutions, these partnerships strengthen IPDA’s mission to
                  build a future-ready, nutrition-smart, and globally
                  competitive pulses ecosystem.
                </p>
                <p className="text-dark fw-bold" data-aos="fade-up">
                  Our mission is to enhance India’s pulses sector through
                  collaboration, capacity building, and market-driven solutions
                  that empower farmers and promote sustainable growth.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* How Can You Collaborate? Section */}
        <section
          className="collaborate section py-5 bg-light"
          data-aos="fade-up"
        >
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h2 className="fw-bold" style={{ color: "#d4561a" }}>
                How Can You Collaborate?
              </h2>
              <p className="text-muted">
                Join us in making a meaningful impact on the pulse industry.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                <div className="card border-0 shadow p-4 text-center">
                  <i
                    className="bi bi-people-fill fs-1 "
                    style={{ color: "#d4561a" }}
                  ></i>
                  <h5 className="mt-3">Partner with Us</h5>
                  <p>
                    Collaborate on research, training, and sustainability
                    projects.
                  </p>
                </div>
              </div>
              <div className="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                <div className="card border-0 shadow p-4 text-center">
                  <i
                    className="bi bi-book-half fs-1 "
                    style={{ color: "#d4561a" }}
                  ></i>
                  <h5 className="mt-3">Attend Training Programs</h5>
                  <p>
                    Gain knowledge and skills from our expert-led training
                    sessions.
                  </p>
                </div>
              </div>
              <div className="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                <div className="card border-0 shadow p-4 text-center">
                  <i
                    className="bi bi-envelope-paper fs-1"
                    style={{ color: "#d4561a" }}
                  ></i>
                  <h5 className="mt-3">Contact Us</h5>
                  <p>
                    Reach out to explore opportunities for collaboration and
                    innovation.
                  </p>
                  <Link to="/contact-us">
                    <button
                      className="btn-cta"
                      style={{
                        backgroundColor: " #d4561a",
                        color: "black",
                        border: "none",
                        borderRadius: "4px",
                      }}
                    >
                      Contact Us
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Collobration;
